import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import type { ReactNode } from "react";

import { CRM_COLORS, formatCrmCount } from "../../lib/crm";
import { CrmCard } from "./CrmCard";

const cellSx = { fontSize: "13px", py: "6px", px: "12px", color: CRM_COLORS.text, verticalAlign: "top" };

type CrmTableCardProps = {
  title: string;
  icon: ReactNode;
  headers: string[];
  rows: { key: string; cells: ReactNode[] }[];
  empty: string;
  actions?: ReactNode;
  testId?: string;
};

// Backend rows on a record page, shown like a related list.
export const CrmTableCard = ({ title, icon, headers, rows, empty, actions, testId }: CrmTableCardProps) => (
  <CrmCard flush testId={testId} icon={icon} title={`${title} (${formatCrmCount(rows.length)})`} actions={actions}>
    {rows.length === 0 ? (
      <Typography sx={{ px: "16px", pb: "12px", fontSize: "13px", color: CRM_COLORS.textWeak }}>{empty}</Typography>
    ) : (
      <Box role="region" aria-label={title} tabIndex={0} sx={{ overflowX: "auto" }}>
        <Table size="small" aria-label={title}>
          <TableHead>
            <TableRow>
              {headers.map(header => (
                <TableCell
                  key={header}
                  sx={{
                    ...cellSx,
                    backgroundColor: CRM_COLORS.tableHeader,
                    color: CRM_COLORS.textWeak,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.key} hover sx={{ "&:hover": { backgroundColor: CRM_COLORS.rowHover } }}>
                {row.cells.map((cell, index) => (
                  <TableCell key={headers[index]} sx={cellSx}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    )}
  </CrmCard>
);
